export default "__VITE_ASSET__0182e5d3__"